import React from "react";
import TeamFormPage from "../components/team/TeamFormPage";

const TeamEdit = () => <TeamFormPage mode="edit" />;

export default TeamEdit;
